export default "__VITE_ASSET__B1Lk0AFO__"